import {Coupon} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/coupon.types';
import {useEffect} from 'react';
import {getCouponPromotionId} from '../../Coupons/getCouponPromotionId';
import {isAppOnlyCoupon} from '../../Coupons/isAppOnlyCoupon';
import {useActivatedCouponState} from '../../Coupons/useActivatedCouponState';

export const useActivateCouponProductByCouponPromotionId = ({
  productId,
  couponPromotionId,
  coupons,
  disabled = false,
}: {
  productId: number;
  couponPromotionId?: string;
  coupons: Coupon[];
  disabled?: boolean;
}) => {
  const {setActivatedCoupon} = useActivatedCouponState(productId);

  useEffect(() => {
    if (!couponPromotionId || disabled) {
      return;
    }

    const coupon = coupons.find(
      coupon => getCouponPromotionId(coupon) === couponPromotionId,
    );

    if (coupon && !isAppOnlyCoupon(coupon)) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setActivatedCoupon(coupon);
    }
  }, [couponPromotionId, coupons, disabled, setActivatedCoupon]);
};
